export default __webpack_public_path__ + "static/media/inspi4.a918968a.jpg";